import React, { useState,useEffect,useCallback,useRef } from "react";
import api from "views/auth/Api";
import { Link } from "react-router-dom";
import "../Myprojects.css"
import { jwtDecode } from "jwt-decode";
import { FiFilePlus } from "react-icons/fi";
import  { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import { MdOutlineSchool } from "react-icons/md";
import { AiOutlineTeam } from "react-icons/ai";
import { RiTeamLine } from "react-icons/ri";
import { BiReset } from "react-icons/bi";
import { IoSearchSharp } from "react-icons/io5";
import CustomDropdown from "../../../../components/Dropdown"
import Loader from "components/loader";

const Projects = () => {
  const [data , setData] = useState([]);
  const [assignData, setAssignData] = useState([]);
  const [current , setCurrent] = useState("All");
  const [subjects , setSubjects] = useState([]);
  const [grades , setGrades] = useState([]);
  const [subject , setSubject] = useState('');
  const [search , setSearch] = useState('');
  const [searchValue , setSearchValue] = useState('');
  const [grade , setGrade] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  
  const subjectRef = useRef();
  const gradeRef = useRef();

  const token = localStorage.getItem('token');
  const decoded = jwtDecode(token);
  const role = decoded.role
  
const limit = 20; 

  const getdrop = async()=>{
    await api.get(`${API_BASE_URL}projects/dropdown`)
  .then(function (response) {
      const subjectNames = [...new Set(response.data?.map(item => item.subject))];
      setSubjects(subjectNames)
      const gradeNames = [...new Set(response.data?.map(item => item.grade))];
      const sorted = gradeNames.sort((a, b) => a - b);
      setGrades(sorted)
  }).catch(error => {
    console.log("handlesubmit error for blog get ", error)
  });
  }
  useEffect(()=>{ 
    getdrop();
  },[]);

const getData = useCallback(async () => {
  setLoading(true);
  if(current === "All"){
  try {
    const res = await api.get(`${API_BASE_URL}projects`, {
      params: { page, limit, search, subject, grade }
    });
    setLoading(false);
    setData(res.data.items);
    setTotalPages(res.data.totalPages);
  } catch (err) {
    console.error(err);
  }}
  else if(current ==="Assigned"){
           api.get(`${API_BASE_URL}assigned-projects`, {
      params: { page, limit, search, subject, grade },
    }).then(function (response) {
                setLoading(false);
                setAssignData(response.data?.items)
                setTotalPages(response.data?.totalPages);
          }).catch(error => {
            console.log("handlesubmit error for blog get ", error)
          });
  }
}, [page, limit, search, subject, grade, current]);

  useEffect(() => {
  getData();
}, [getData]); // now this is valid

  const allProjects =() => {
      setCurrent("All");
        setPage(1)
        setSubject('');
        setGrade('');
        setSearch('');
        setSearchValue('');
    }

  const assignedProjects =() => {
    setCurrent("Assigned");
    setPage(1)
        setSubject('');
        setGrade('');
        setSearch('');
        setSearchValue('');
        }

//                           All projects filters     //

 
// const subjectsData = ()=> { 
//   let oppmodels =[]
//   for (let i = 0; i < subjects.length; i++) {
//  oppmodels.push(<option value={subjects[i]} >{subjects[i]}</option>)
//  }
//  return oppmodels
// }

const newSubject = (e)=>{
  setSubject(e)
  setPage(1);
}
const newGrade = (e)=>{
  setGrade(e)
  setPage(1);
}
  //                           Assinged projects filters     //
 
 return (
    <div className="vhReview">
      <div className="teachersearch">
       
        <div className="search-devs" >
          <div className="search-form">
            <div className="searchImg"></div>
            <input className="search-input" placeholder="Search here" 
                    type="text"
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e.target.value)}}
                      onKeyDown={(e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value)
      setPage(1);
    }}}/>
 <span className="newSearchIcon" onClick={() => {setSearch(searchValue)
    setPage(1);
 }}>
    <IoSearchSharp className="w-[25px] h-[25px]"/></span>
             </div>
      <div className="w-[180px]">
        <CustomDropdown options={subjects}
       selectedd={newSubject}
       ref={subjectRef}
       type="Subject"
        /></div>
        <div className="w-[90px]">
        <CustomDropdown options={grades}
       selectedd={newGrade}
       ref={gradeRef}
       type="Grade" 
        /></div>

      <div className="filterReq flex items-center" onClick={()=>{
        setSubject('');
        setGrade('');
        setSearch('');
        setSearchValue('');
        gradeRef.current.rest();
        subjectRef.current.rest();
        setPage(1);
      }}>
        <BiReset className="addImg"/>
        <span className="ml-[5px]">Reset</span>
      </div>
        </div>

        <div className="ChallangesTrNew">
                  <div className="flex">
           <span className={current==="All" ? "trChActive" : "trChNoactive"} onClick={() => allProjects()}>All Projects</span>
           {role === "Teacher" ? <span className={current==="Assigned" ? "trChActive" : "trChNoactive"} onClick={() => assignedProjects()}>Assigned Projects</span> : null}
           </div>
    {role === "Admin" ? <Link to={"/admin/tr/projects/add"}>  <div className="newChallenge">
        <FiFilePlus className="addImg"/>
        <span>Add Project</span>
      </div> </Link> : null}
          </div>
      </div>
        {/* Projects cards */}
    <div className="projectsDesc">
            <div className="challangeslist">
              <div className="projects-continar">
              { loading ? <Loader loading={loading} /> : !data[0] & current === "All" & !loading || !assignData[0] & current === "Assigned" & !loading  ?  <span>NO Projects Available</span> : null}
          {current === "All" ? data.map(project => <Link to={`/admin/tr/projects/main/${project.id}`}> 
                          <div className="projectsCards">
                          <div className="cardImg-Pro" style={{backgroundImage:`url(${FILES_URL}${project.img?.url})`}}></div>
                          <div className="cardInfo-Pro">
                              <h4 className="text-lg font-bold text-navy-700 capitalize h-[56px] overflow-hidden">{project.projectName}</h4>
                              <div className="mt-3"> {role === "Admin" && project.curricula ? <span className="text-l font-bold text-amber-600 capitalize mr-[20px] ">{project.curricula}</span> : null } <span className=" text-l font-bold capitalize ntfCrdSubject">{project.subject}</span></div>
                              <p className="mt-1 text-sm font-medium text-gray-600 md:mt-2"> <b>Lesson :</b> {project.lesson} </p>
                               <div className="gradeProDev">
                              <MdOutlineSchool className="gradesIcon"/>
                                <p> {project.grade} </p>
                                            </div>
                            </div>
                        </div> </Link>):null}
         {current === "Assigned" ? assignData.map(project => <Link to={`/admin/tr/projects/main/assign/${project?.id}`}> 
                          <div className="projectsCards">
                          <div className="cardImg-Pro" style={{backgroundImage:`url(${FILES_URL}${project.project?.img?.url})`}}></div>
                          <div className="cardInfo-Pro">
                              <h4 className="text-lg font-bold text-navy-700 capitalize h-[56px]">{project.project?.projectName}</h4>
                              <span className="mt-3 text-l font-bold capitalize ntfCrdSubject">{project.project?.subject}</span>
                              <p className="mt-1 text-sm font-medium text-gray-600 md:mt-2"> <b>Lesson :</b> {project.project?.lesson} </p>
                    <div className="assignDetails gradeProDev">
                <div className="clockIconDev">
                  <MdOutlineSchool className="gradesIcon"/>
                   <span>Grade {project.project?.grade}</span>
                </div>

                <div className="clockIconDev">
                  <RiTeamLine className="classIcon"/>
                   <span>Class {project.class.class}</span>
                </div>

                <div className="clockIconDev">
                  <AiOutlineTeam className="teamIcon"/>
                   <span>Team Size {project.teamSize}</span>
                </div>
                </div>
                            </div>
                            
                        </div> </Link>):null}
        </div>      
      </div>
    </div>
       {!data[0] & current === "All" || !assignData[0] & current === "Assigned"  ?  null :
       <div className="flex items-center justify-center mt-6 mb-8 gap-3 bottom-0 ">
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`min-w-[40px] px-3 py-2 rounded-lg ${
              page === i + 1
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>}

    </div>
  );
};

export default Projects;
